<template>
  <div>
    <OneAssignment ref="oa" @success="OaSuccess" :type="-1" :listType="2" :isHome="true" />
    <div class="breadcrumb-wrap">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        class="breadcrumb-custom"
      >
        <el-breadcrumb-item>工艺选画标签管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="a-t">
      <el-button @click="handleAddTag" type="primary">
        分配
      </el-button>
    </div>
    <LoadingNoDialog :loading="loading">
      <el-table
        class="clear-fix"
        border
        :empty-text="emptyText"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"> </el-table-column>
        <el-table-column label="名称" prop="name"> </el-table-column>

        <el-table-column prop="payCode" label="图片">
          <template slot-scope="scope">
            <img :src="scope.row.img" style="height: 140px" />
          </template>
        </el-table-column>
        <el-table-column prop="payCode" label="顺序操作">
          <template slot-scope="scope">
            <el-button @click="e=>handleMove(1,scope.row)">上移</el-button>
             <el-button @click="e=>handleMove(-1,scope.row)">下移</el-button>
          </template>
        </el-table-column>
      
        <el-table-column prop="createdAt" label="创建时间"> </el-table-column>
      </el-table>

    
    </LoadingNoDialog>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import LoadingNoDialog from "../../components/LoadingNoDialog.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button.vue";
import TagImgUpload from "./component/TagImgUpload.vue";
import OneAssignment from "./component/OneAssignment.vue";
export default {
  name: "Role",
  data() {
    return {
      emptyText: "暂无数据",
      size: 10,
      page: 1,
      tableData: [],
      total: 0,
      loading: false,
      tagImgDialog: false,
      tagInfo: {
        objectKey: "",
        imgUrl: "",
      },
      subTagLoading: false,
      isAdd: true,
    };
  },
  components: {
    ElButton,
    LoadingNoDialog,
    TagImgUpload,
    OneAssignment,
  },
  mounted() {
    this.getList();
  },
  methods: {
    async handleMove(order,row){

    const loading = this.$loading({
          lock: true,
          text: "提交中",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });
      let r=await axios.post('/tag/tag/move',{type:-1,tagId:row.id,order})
      if(r.code==0){
        loading.close()
        this.getList()
      }
    },
    OaSuccess(){
      this.getList()
    },
   
    

    handleAddTag() {
       this.$refs.oa.setMyRow(this.tableData);
    },
    
  
   

   
    async getList() {
      this.loading = true;
      let r = await axios.get("/admin/get-main-tag", {
        params: { type:-1},
      });
      if (r.code == 51) {
        this.loading = false;
        this.emptyText = "无权限";
        return;
      }
      this.tableData = r.data.map((item) =>
        Object.assign(item, {
          createdAt: moment(item.createdAt).format("YYYY/MM/DD HH:mm:ss"),
        })
      );

      this.total = r.data.count;
      this.loading = false;
    },
   
  },
};
</script>
<style scoped>
.t-u-w {
  display: flex;
  justify-content: center;
}
.a-t {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/admin/HomeTag.vue